import React, { Component, Fragment } from 'react';
import { Route, Switch } from 'react-router-dom';
import { LayoutManagerProvider } from '@thd-olt-component/layout-manager';
import HomePage from './pages/HomePage';
import BrowseSearchPage from './pages/BrowseSearchPage';
import CollectionPage from './pages/CollectionPage';
import ProductPage from './pages/ProductPage';
import ErrorPage from './pages/ErrorPage';
import ProductEntryPage from './pages/ProductEntryPage';
import AppWrapper from './components/App';
import './overrides.scss';
import rules from './rules.json';

export class App extends Component {
  render() {
    return (
      <AppWrapper {...this.props}>
        <LayoutManagerProvider context={rules}>
          <Switch>
            <Route path="/error/:context?" component={ErrorPage} />
            <Route exact path="/:context?/pep/:slug?/:itemId" render={props => <ProductEntryPage {...props} />} />
            <Route path="/:context?/b/*" render={props => <BrowseSearchPage {...props} />} />
            <Route path="/:context?/collection/:category?/:slug?/:familyId" render={props => <CollectionPage {...props} />} />
            <Route path="/:context?/p/:slug/:itemId" render={props => <ProductPage {...props} />} />
            <Route exact path="/:context?/p/:itemId" render={props => <ProductPage {...props} />} />
            <Route path="/:context?/s/:sValue" render={props => <BrowseSearchPage {...props} />} />
            <Route exact path="/:context?/" render={props => <HomePage {...props} />} />
            <Route component={ErrorPage} />
          </Switch>
        </LayoutManagerProvider>
      </AppWrapper>
    );
  }
}

App.propTypes = {};

export default App;
